import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getStoreLocationsDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  storeLocations: [
    {
      fieldName: "Store Locations (English)",
      fieldValue: "data.title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "text",
      name: "field_content_english_title",
      formType: "input",
      label: "Title (English)",
      placeholder: "Enter Title (English)",
      validation: { required: "Title (English) is required" },
    },
  ],

  airport: [
    {
      fieldName: "Airport (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Airport (EN)",
      placeholder: "Enter Airport (EN)",
      validation: { required: "Airport (EN) is required" },
    },
    {
      fieldName: "Airport (MS)",
      fieldValue: "field_airport_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_airport_name_ms",
      formType: "input",
      label: "Airport (MS)",
      placeholder: "Enter Airport (MS)",
      // validation: { required: "Airport Name is required" },
    },
    {
      fieldName: "Airport (ZH)",
      fieldValue: "field_airport_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_airport_name_zh",
      formType: "input",
      label: "Airport (ZH)",
      placeholder: "Enter Airport (ZH)",
      // validation: { required: "Airport Name is required" },
    },
    {
      fieldName: "Airport Name - Code",
      fieldValue: "field_airport_codes",
      className: "col-span-6",
      type: "text",
      name: "field_airport_codes",
      formType: "input",
      label: "Airport Name - Code",
      placeholder: "Enter Airport Name - Code",
      validation: { required: "Airport Name - Code is required" },
    },
    {
      fieldName: "Contact Name",
      fieldValue: "field_airport_contact_name",
      className: "col-span-6",
      type: "text",
      name: "field_airport_contact_name",
      formType: "input",
      label: "Contact Name",
      placeholder: "Contact Name",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Contact Number",
      fieldValue: "field_airport_contact_number",
      className: "col-span-6",
      type: "text",
      name: "field_airport_contact_number",
      formType: "input",
      label: "Contact Number",
      placeholder: "Contact Number",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Ranking",
      fieldValue: "field_airport_ranking",
      className: "col-span-6",
      type: "text",
      name: "field_airport_ranking",
      formType: "input",
      label: "Ranking",
      placeholder: "Enter Ranking",
      validation: { required: "Ranking is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],

  level: [
    {
      fieldName: "Airport",
      fieldValue: "field_location_airports",
      className: "col-span-6",
      type: "select",
      name: "field_location_airports",
      formType: "select",
      label: "Airport",
      placeholder: "Select Airport",
      options: [],
      validation: { required: "Airport is required" },
    },
    {
      fieldName: "Outlet",
      fieldValue: "field_stores_of_levels",
      className: "col-span-6",
      type: "select",
      name: "field_stores_of_levels",
      formType: "multiSelect",
      label: "Outlet",
      placeholder: "Select Outlet",
      options: [],
      validation: { required: "Store is required" },
      },
  {
    fieldName: "Level (EN)",
    fieldValue: "field_location_level_name",
    className: "col-span-6",
    type: "text",
    name: "field_location_level_name",
    formType: "input",
    label: "Level (EN)",
    placeholder: "Enter Level (EN)",
    validation: { required: "Level (EN) is required" },
  },
  {
    fieldName: "Level (MS)",
    fieldValue: "field_location_level_name_ms",
    className: "col-span-6",
    type: "text",
    name: "field_location_level_name_ms",
    formType: "input",
    label: "Level (MS)",
    placeholder: "Enter Level (MS)",
  },
  {
    fieldName: "Level (ZH)",
    fieldValue: "field_location_level_name_zh",
    className: "col-span-6",
    type: "text",
    name: "field_location_level_name_zh",
    formType: "input",
    label: "Level (ZH)",
    placeholder: "Enter Level (ZH)",
  },
  {
    fieldName: "Store Location Code",
    fieldValue: "field_store_location_code",
    className: "col-span-6",
    type: "text",
    name: "field_store_location_code",
    formType: "input",
    label: "Store Location Code",
    placeholder: "Enter Store Location Code",
    validation: { required: "Store Location Code is required" },
  },
  // {
  //   fieldName: "Level Icon",
  //   fieldValue: "field_location_icon",
  //   className: "col-span-6",
  //   type: "image",
  //   name: "field_location_icon",
  //   formType: "file",
  //   usedFileType: 'image/*',
  //   label: "Level Icon",
  //   placeholder: "Enter Level Icon",
  //   validation: { required: "Level Icon is required" },
  // },
  {
    fieldName: "Floor Image",
    fieldValue: "field_location_level_image",
    className: "col-span-6",
    type: "image",
    name: "field_location_level_image",
    formType: "file",
    usedFileType: 'image/*',
    label: "Floor Image",
    placeholder: "Enter Image",
    validation: { required: "Floor Image is required" },
    imageDimension: {
        width: 953,
        height: 740
      }
  },
  {
    fieldName: "Ranking",
    fieldValue: "field_ranking",
    className: "col-span-6",
    type: "text",
    name: "field_ranking",
    formType: "input",
    label: "Ranking",
    placeholder: "Enter Ranking",
    validation: { required: "Ranking is required" },
  },
  {
    fieldName: "Published",
    fieldValue: "published",
    className: "col-span-12",
    type: "checkbox",
    name: "published",
    formType: "checkbox",
    label: "Published",
    placeholder: "Enter Published",
  },
  ],

  outlet: [
     {
      fieldName: "Outlet (EN)",
      fieldValue: "field_stores_name",
      className: "col-span-6",
      type: "text",
      name: "field_stores_name",
      formType: "input",
      label: "Outlet (EN)",
      placeholder: "Enter Outlet (EN)",
      validation: { required: "Outlet (EN) is required" },
    },
    {
      fieldName: "Outlet (MS)",
      fieldValue: "field_stores_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_stores_name_ms",
      formType: "input",
      label: "Outlet (MS)",
      placeholder: "Enter Outlet (MS)",
      // validation: { required: "Outlet (MS) is required" },
    },
    {
      fieldName: "Outlet (ZH)",
      fieldValue: "field_stores_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_stores_name_zh",
      formType: "input",
      label: "Outlet (ZH)",
      placeholder: "Enter Outlet (ZH)",
      // validation: { required: "Outlet (ZH) is required" },
    },
    // {
    //   fieldName: "Airport",
    //   fieldValue: "field_location_airports",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_location_airports",
    //   formType: "input",
    //   label: "Airport",
    //   placeholder: "Enter Airport",
    //   validation: { required: "Airport is required" },
    // },
    {
      fieldName: "Opening Hours",
      fieldValue: "field_store_time",
      className: "col-span-6",
      type: "text",
      name: "field_store_time",
      formType: "input",
      label: "Opening Hours",
      placeholder: "Enter Open Hours",
      validation: { required: "Opening Hours is required" },
    },
    {
      fieldName: "Address",
      fieldValue: "field_store_description",
      className: "col-span-6",
      type: "text",
      name: "field_store_description",
      formType: "input",
      label: "Address",
      placeholder: "Enter Address",
      validation: { required: "Address is required" },
    },
    // {
    //   fieldName: "Level",
    //   fieldValue: "field_location_level_name",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_location_level_name",
    //   formType: "input",
    //   label: "Level",
    //   placeholder: "Enter Level",
    //   validation: { required: "Level is required" },
    // },
    // {
    //   fieldName: "Time Icon",
    //   fieldValue: "field_time_icon",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_time_icon",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Image",
    //   placeholder: "Enter Image",
    //   validation: { required: "Image is required" },
    // },
    {
      fieldName: "Outlet Floor Image",
      fieldValue: "field_store_main_image",
      className: "col-span-6",
      type: "image",
      name: "field_store_main_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Enter Outlet Floor Image",
      validation: { required: "Outlet Floor Image is required" },
      imageDimension: {
        width: 953,
        height: 740
      }
    },
    {
      fieldName: "Outlet Image",
      fieldValue: "field_store_description_image",
      className: "col-span-6",
      type: "image",
      name: "field_store_description_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Enter Outlet Image",
      validation: { required: "Outlet Image is required" },
      imageDimension: {
        width: 215,
        height: 170
      }
    },
    // {
    //   fieldName: "Ranking",
    //   fieldValue: "field_ranking",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_ranking",
    //   formType: "input",
    //   label: "Ranking",
    //   placeholder: "Enter Ranking",
    //   validation: { required: "Ranking is required" },
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
};
